import React from "react";
import FormFunc from "../../../utils/FormFunc";
import Feature from "../../../utils/Feature";
import { useInfo } from "context/InfoContext";
import UserInfoPhotoUpload from "../UserInfoPhotoUpload";

export default function PersonalDataContent({
  boxName,
  userData,
  handleEvents,
}) {
  const { filters, filterData } = useInfo();
  const addClass = "col s4";
  const isCannotEdit =
    userData?.user_sess?.userCanAccessHrAssign ||
    userData?.user_sess?.isAdmin ||
    userData?.idu === filters?.idu
      ? false
      : true;
  const isYourProfile = userData?.idu === filters?.idu ? true : false;
  return (
    <div key={"personal-data-content-" + boxName + "-" + filters.key_form}>
      <UserInfoPhotoUpload
        filters={filters}
        boxName={boxName}
        isCannotEdit={isCannotEdit}
        isYourProfile={isYourProfile}
        handleEvents={handleEvents}
      />
      <div className={boxName + " row"} id={boxName + "-row-1"}>
        <FormFunc.InputText
          data={{
            name: "contact_fullname_local_language",
            label: "Full Name In Local Language",
            addClass: "col s8",
            disabled: isCannotEdit,
          }}
          filters={filters}
          events={handleEvents}
        />
        <FormFunc.SingleSelect
          data={{
            name: "native_language",
            label: "Native Language*",
            options: filterData.data.native_languages,
            addClass: addClass,
            optionName: "name",
            optionValue: "name",
            optionTitle: "---",
            disabled: isCannotEdit,
            required: true,
          }}
          filters={filters}
          events={handleEvents}
        />
      </div>
      <div className={boxName + " row"}>
        <FormFunc.InputText
          data={{
            name: "contact_note",
            label: "Note",
            addClass: "col s8",
            disabled: isCannotEdit,
          }}
          filters={filters}
          events={handleEvents}
        />
      </div>
      <div className={boxName + " row"} id={boxName + "-row-3"}>
        <FormFunc.InputText
          data={{
            name: "contact_email",
            label: "Personal E-mail*",
            addClass: addClass,
            disabled: isCannotEdit,
          }}
          filters={filters}
          events={handleEvents}
        />
        <FormFunc.InputText
          data={{
            name: "contact_home_phone",
            label: "Home Phone",
            addClass: addClass,
            disabled: isCannotEdit,
          }}
          filters={filters}
          events={handleEvents}
        />
        <FormFunc.InputText
          data={{
            name: "contact_mobile",
            label: "Mobile Phone",
            addClass: addClass,
            disabled: isCannotEdit,
          }}
          filters={filters}
          events={handleEvents}
        />
      </div>
      <div className={boxName + " row"} id={boxName + "-row-4"}>
        <FormFunc.InputText
          data={{
            name: "contact_address",
            label: "Address 1",
            addClass: addClass,
            disabled: isCannotEdit,
          }}
          filters={filters}
          events={handleEvents}
        />
        <FormFunc.InputText
          data={{
            name: "contact_street",
            label: "Address 2",
            addClass: addClass,
            disabled: isCannotEdit,
          }}
          filters={filters}
          events={handleEvents}
        />
        <FormFunc.InputText
          data={{
            name: "contact_city",
            label: "City",
            addClass: addClass,
            disabled: isCannotEdit,
          }}
          filters={filters}
          events={handleEvents}
        />
        {/* <FormFunc.SingleSelect
          data={{
            name: "contact_city",
            label: "City",
            options: Feature.GetDataRelateCountry(
              filterData.data.locations,
              filters,
              ["contact_country_code"]
            ),
            // options: filterData.data.locations,
            addClass: addClass,
            optionName: "city",
            optionValue: "city",
            optionGroup: true,
            optionTitle: "---",
            disabled: isCannotEdit,
          }}
          filters={filters}
          events={handleEvents}
        /> */}
      </div>
      <div className={boxName + " row"}>
        <FormFunc.InputText
          data={{
            name: "contact_state",
            label: "State/Province",
            addClass: addClass,
            disabled: isCannotEdit,
          }}
          filters={filters}
          events={handleEvents}
        />
        <FormFunc.SingleSelect
          data={{
            name: "contact_country",
            label: "Country",
            options: Feature.GetCountryExcludeEXOGroup(
              filterData.data.workcountries
            ),
            addClass: addClass,
            optionName: "country_name",
            optionValue: "country_name",
            optionTitle: "---",
            disabled: isCannotEdit,
            // defaultValue: filters?.contact_country ?? "",
          }}
          filters={filters}
          events={handleEvents}
        />
        <FormFunc.InputText
          data={{
            name: "contact_zipcode",
            label: "Zip Code",
            addClass: addClass,
            disabled: isCannotEdit,
          }}
          filters={filters}
          events={handleEvents}
        />
      </div>
      <div className={boxName + " row"}>
        <FormFunc.SingleSelect
          data={{
            name: "gender",
            label: "Gender*",
            options: filterData.data.genders,
            addClass: addClass,
            optionName: "name",
            optionValue: "value",
            optionTitle: "---",
            disabled: isCannotEdit,
            required: true,
          }}
          filters={filters}
          events={handleEvents}
        />
        <FormFunc.SingleSelect
          data={{
            name: "nationality",
            label: "Nationality*",
            options: filterData.data.nationalities,
            addClass: addClass,
            optionName: "name",
            optionValue: "name",
            optionTitle: "---",
            disabled: isCannotEdit,
            required: true,
          }}
          filters={filters}
          events={handleEvents}
        />
        <FormFunc.InputDate
          data={{
            name: "birthday",
            label: "Date of Birth*",
            addClass: addClass,
            disabled: isCannotEdit,
            required: true,
          }}
          filters={filters}
          events={handleEvents}
        />
      </div>
      <div className={boxName + " row"} style={{ paddingBottom: "20px" }}>
        <FormFunc.SingleSelect
          data={{
            name: "religion",
            label: "Religion",
            options: filterData.data.religions,
            addClass: addClass,
            optionName: "name",
            optionValue: "name",
            optionTitle: "---",
            disabled: isCannotEdit,
          }}
          filters={filters}
          events={handleEvents}
        />
        <FormFunc.SingleSelect
          data={{
            name: "marital_status",
            label: "Marital Status",
            options: filterData.data.maritals,
            addClass: addClass,
            optionName: "name",
            optionValue: "name",
            optionTitle: "---",
            disabled: isCannotEdit,
          }}
          filters={filters}
          events={handleEvents}
        />
      </div>
      <div className={boxName + " row"}>
        <FormFunc.InputText
          data={{
            name: "contact_emergency_contact_name",
            label: "Emergency Contact Name",
            addClass: addClass,
            disabled: isCannotEdit,
          }}
          filters={filters}
          events={handleEvents}
        />
        <FormFunc.InputText
          data={{
            name: "contact_emergency_contact_number",
            label: "Emergency Contact Number",
            addClass: addClass,
            disabled: isCannotEdit,
          }}
          filters={filters}
          events={handleEvents}
        />
      </div>
    </div>
  );
}
